"use strict";export const ASSET_VARIANTS=["file","folder"];
//# sourceMappingURL=Asset.types.js.map
